type BHCheckboxProps = {
  className?: string
  title: string
  currentValue: boolean
  onChange: (value: boolean) => void
  onFocus?: () => void
  onBlur?: () => void
  disabled?: boolean
}

function BHCheckbox({
  className,
  title,
  currentValue,
  onChange,
  onFocus,
  onBlur,
  disabled,
}: BHCheckboxProps) {
  return (
    <div className={`${className ? className : ''}`}>
      <label className="items-center">
        <input
          required
          onChange={(e) => onChange(e.target.checked)}
          type="checkbox"
          color="red"
          disabled={disabled}
          checked={currentValue}
          onFocus={onFocus}
          onBlur={onBlur}
        />
        <span className="ml-2">{title}</span>
      </label>
    </div>
  )
}

export default BHCheckbox
